// src/composables/useToast.js
import { ref } from 'vue';

const toasts = ref([]); // آرایه‌ای برای نگهداری تمام پیام‌های Toast فعال
let toastIdCounter = 0; // برای دادن یک ID یکتا به هر Toast

export function useToast() {

  // تابع اصلی نمایش Toast که حالا هوشمندتر عمل می‌کند و با تاخیر پیام‌های آرایه‌ای را نمایش می‌دهد
  const showToast = (messageInput, type = 'info', duration = 3000, delayBetweenToasts = 500) => {
    // بررسی می‌کند که messageInput یک آرایه است یا نه
    if (Array.isArray(messageInput)) {
      // اگر آرایه بود، برای هر پیام در آرایه یک Toast جداگانه ایجاد می‌کند با تاخیر
      messageInput.forEach((msg, index) => {
        // هر Toast را با تاخیری که از index و delayBetweenToasts محاسبه می‌شود، اضافه می‌کنیم
        setTimeout(() => {
          const id = toastIdCounter++;
          toasts.value.push({ id, message: msg, type, duration });
        }, index * delayBetweenToasts); // تاخیر برای هر پیام در آرایه
      });
    } else {
      // اگر آرایه نبود (یک رشته تکی بود)، یک Toast واحد بدون تاخیر اضافی ایجاد می‌کند
      const id = toastIdCounter++;
      toasts.value.push({ id, message: messageInput, type, duration });
    }
    // نکته: مدیریت حذف Toast همچنان توسط ToastNotification یا تابع removeToast انجام می‌شود.
  };

  const showSuccess = (messageInput, duration = 3000, delayBetweenToasts = 500) => {
    showToast(messageInput, 'success', duration, delayBetweenToasts);
  };

  const showError = (messageInput, duration = 5000, delayBetweenToasts = 500) => {
    showToast(messageInput, 'error', duration, delayBetweenToasts);
  };

  const showWarning = (messageInput, duration = 4000, delayBetweenToasts = 500) => {
    showToast(messageInput, 'warning', duration, delayBetweenToasts);
  };

  const showInfo = (messageInput, duration = 3000, delayBetweenToasts = 500) => {
    showToast(messageInput, 'info', duration, delayBetweenToasts);
  };

  // تابع برای حذف Toast از آرایه (فراخوانی شده توسط والد پس از رویداد destroy)
  const removeToast = (id) => {
    toasts.value = toasts.value.filter(toast => toast.id !== id);
  };

  return {
    toasts,
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    removeToast,
  };
}
